export const C4CNovo = 'Novo C4C';
